import { render, staticRenderFns } from "./order.vue?vue&type=template&id=37aba124&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=37aba124&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aba124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37aba124')) {
      api.createRecord('37aba124', component.options)
    } else {
      api.reload('37aba124', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=37aba124&scoped=true&", function () {
      api.rerender('37aba124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/touristAttraction/order.vue"
export default component.exports